export default __webpack_public_path__ + "static/Junk-Cleanup-and-Hauling-c37dca2128ce26f672434b997984aa97.jpg";